import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../app-footer/footer.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { LoadingService } from '../../../core/services/shared-services/loading.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [RouterOutlet,HeaderComponent,FooterComponent,MatProgressSpinner,CommonModule],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss'
})
export class LayoutComponent {
  private loader = inject(LoadingService);
  loading$ = this.loader.loading$;
}
